import { createMeta } from "../../../components/TapHeader";

const title = "Pricing";
export const OrgPricingMeta = createMeta(title);
